document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("form").forEach(form => {
    attachValidation(form);
  });

  function attachValidation(form) {
    const submitButton = form.querySelector("button[type='submit']");
    
    if (!submitButton) return;

    submitButton.addEventListener("click", function (event) {
      event.preventDefault();
      if (validateForm(form)) {
        form.submit();
      }
    });

    form.querySelectorAll("input, textarea").forEach(field => {
      field.addEventListener("input", function () {
        this.classList.remove("field--error");
        const error = this.parentNode.querySelector(".form__field-error");
        if (error) {
          error.remove();
        }
      });
    });
  }

  function validateForm(form) {
    let isValid = true;

    form.querySelectorAll(".form__field-error").forEach(error => error.remove());

    form.querySelectorAll("input[required], textarea[required]").forEach(field => {
      if (!field.value.trim()) {
        isValid = false;
        displayError(field, `${window.formValidation.required}`);
      } else if (field.value.length > 255) {
        isValid = false;
        displayError(field, `${window.formValidation.length_range}`);
      }
    });

    form.querySelectorAll("textarea").forEach(field => {
      if (field.value.length > 255) {
        isValid = false;
        displayError(field, `${window.formValidation.length_range}`);
      }
    });
    

    const emailField = form.querySelector("input[type='email']");
    if (emailField && !validateEmail(emailField.value)) {
      isValid = false;
      displayError(emailField, `${window.formValidation.email}`);
    }

    const phoneField = form.querySelector("input[type='tel']");
    if (phoneField && !validatePhone(phoneField.value)) {
      isValid = false;
      displayError(phoneField, `${window.formValidation.telephone}`);
    }

    return isValid;
  }

  function validateEmail(email) {
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(email);
  }

  function validatePhone(phone) {
    return /^[0-9]{10,}$/.test(phone.trim());
  }

  function displayError(field, message) {
    if (!field) return;

    let existingError = field.nextElementSibling;
    if (existingError?.classList.contains("form__field-error")) {
      existingError.innerHTML = `${message}`;
      return;
    }

    const error = document.createElement("small");
    error.className = "form__field-error";
    error.innerHTML = `${message}`;

    field.insertAdjacentElement("afterend", error);
    field.classList.add("field--error");
  }
});
